import { boolean, object, string } from 'yup'

export interface IConfigurableBuilderSchema {
  id: string
  name: string
  transactionSetWithSubtype: string
  isLive: boolean
}

export const ConfigurableBuilderSchema = object<IConfigurableBuilderSchema>({
  id: string(),
  name: string().required('Name is required'),
  transactionSetWithSubtype: string().required(),
  isLive: boolean(),
})
